import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { Text } from '@travel-frontend/core';
import { Children, Fragment } from 'react';
import { Placeholder } from '../../../../primitives/Select/components/Placeholder/index.js';
import { Container } from '../../../../primitives/Select/components/ValueContainer/components/Container.js';
import { Truncate } from '../../../../primitives/Typography/index.js';
export const ValueContainer = ({
  children,
  ...restProps
}) => {
  const {
    selectProps,
    getStyles,
    hasValue
  } = restProps;
  const {
    isPinned,
    size,
    controlIcon,
    centered,
    isMulti,
    multiValuePrefix
  } = selectProps;
  const multiValueChildren = isMulti && Array.isArray(children) && Array.isArray(children[0]) ? children[0] : [];
  return _jsxs(Container
  // @ts-expect-error FIXME
  , {
    // @ts-expect-error FIXME
    reactSelectStyles: getStyles('valueContainer', restProps),
    "data-label": "[]",
    size: size,
    controlIcon: !!controlIcon,
    centered: centered === true,
    children: [(selectProps.isSearchable || isPinned || !hasValue) && _jsx(Placeholder, {
      ...restProps,
      children: selectProps.placeholder
    }), multiValueChildren.length > 0 && _jsxs(_Fragment, {
      children: [multiValuePrefix && _jsxs(Text, {
        as: "span",
        preset: "labelMedium",
        color: "contentPrimary",
        style: {
          flexShrink: 0
        },
        children: [multiValuePrefix, "\u00A0"]
      }), _jsx(Text, {
        as: "span",
        preset: "labelMediumBold",
        color: "interactionSecondary",
        children: _jsx(Truncate, {
          children: multiValueChildren.map((child, index) => _jsxs(Fragment, {
            children: [child, index < multiValueChildren.length - 1 && ', ']
          }, index))
        })
      })]
    }), Children.map(children, child => {
      if (child && typeof child === 'object' && 'type' in child && child.type !== Placeholder && !multiValueChildren.includes(child)) {
        return child;
      }
    })]
  });
};